<!-- app.component.html -->
<div class="classifier">
  <div style="position: relative;">
    <img #imageSource id="imageSource" [src]="imageSrc" style="position: absolute; left: 0; top: 0;">
  </div>
  <canvas #layer1 id="layer1" [width]="imgWidth" [height]="imgHeight"
        style="position: absolute; left: 0; top: 0;"
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mouseup)="onMouseUp()">
  </canvas>
</div>
<div class="location">
  <span>
    x: {{x}} y: {{y}}
  </span>    
  <!--<span *ngIf="classification">
    x: {{classification.x}} y: {{classification.y}} w: {{classification.width}} y: {{classification.height}}
  </span>    -->

</div>
<div class="confidence-slider">
  <label for="confidenceSlider">Confidence: {{confidencePercentage}}%</label>
  <input type="range" id="confidenceSlider" min="0" max="100" [(ngModel)]="confidencePercentage" (input)="onConfidenceChange()" />
</div>